export const prevArrow = `
    <button class="slick-arrow slick-prev button z-10" aria-label="Previous slide">
        ${Nu.arrows.left}
    </button>`;
export const nextArrow = `
    <button class="slick-arrow slick-next button z-10" aria-label="Next slide">
        ${Nu.arrows.right}
    </button>`;

export const options = {
    slidesToShow: 1,
    swipeToSlide: true,
    infinite: false,
    cssEase: "ease",
    mobileFirst: true,
    speed: 600,
    rows: 0,
    respondTo: "slider",
    nextArrow: nextArrow,
    prevArrow: prevArrow,
};
